import React, { useState, useEffect } from 'react';
import { ListGroup, Spinner } from 'react-bootstrap';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';
import navigation from '../../../menu-items';
import { BASE_TITLE } from '../../../config/constant';
import SearchInput from '../../../common/SearchInput';
// import CommonDropdown from '../../../common/commonDropdown';
import CommonButton from '../../../common/CommonButton';
import CommonModal from '../../../common/CommonModal';
import ModalFooter from '../../../common/ModalFooter';
import { useNavigate } from 'react-router-dom';
import { getSubscriptionTier, getAuditorsLimit, getDelegateAdminsLimit } from '../../../util/subscription';
import { useNotification } from '../../../contexts/NotificationContext';
import docIcon from '../../../assets/images/doc_report.png';

const Breadcrumb = () => {
  const { showNotification } = useNotification();
  const location = useLocation();
  const isSiteDetailPage = location.pathname.startsWith('/admin/manage-sites/') && location.pathname !== '/admin/manage-sites';
  const isAssessmentPage = location.pathname.startsWith('/admin/site/') && location.pathname.includes('/assessment/');
  const isDashboardPage = location.pathname === '/admin/dashboard' || location.pathname === '/';

  const [searchParams, setSearchParams] = useSearchParams();
  const [main, setMain] = useState([]);
  const [item, setItem] = useState([]);
  // eslint-disable-next-line
  const [siteNameVersion, setSiteNameVersion] = useState(0);

  const navigate = useNavigate();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const isDelegateAdmin =
    userInfo.role_name === 'DeletegateAdmin' || userInfo.role_id === 4 || userInfo.role_id === '4' || userInfo.role === 'Delegate Admin';
  const isSuperAdmin = userInfo.role_name === 'SuperAdmin';
  const userPermissions = userInfo.permissions || userInfo;

  const canManageAuditor = isDelegateAdmin ? userPermissions.manage_auditor === 1 : true;
  const canManageCustomRole = isDelegateAdmin ? userPermissions.manage_custom_role === 1 : true;
  const canManageTemplate = isDelegateAdmin ? userPermissions.manage_template === 1 : true;
  const canManageIBP = isDelegateAdmin ? userPermissions.ibp_ref === 1 : true;
  const canManageSites = isDelegateAdmin ? userPermissions.auditor_audit === 1 : true;
  const canManageChapter = isDelegateAdmin ? userPermissions.manage_chapter === 1 : true;
  const canManageSupportTicket = isDelegateAdmin ? Number(userPermissions.manage_support_ticket) === 1 : true;
  const [upgradeTitle, setUpgradeTitle] = useState('Upgrade Required');
  const [upgradeMessage, setUpgradeMessage] = useState('Upgrade your subscription to access features.');
  const [upgradeSubmitLabel, setUpgradeSubmitLabel] = useState('Upgrade Plan');
  const [upgradeType, setUpgradeType] = useState(null);

  const [sub, setSub] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('userInfo') || '{}')?.subscription || 'Basic';
    } catch {
      return 'Basic';
    }
  });
  const [activeAuditorsCount, setActiveAuditorsCount] = useState(() => {
    return Number(localStorage.getItem('active_auditors_count') || '0');
  });
  const [activeDelegatesCount, setActiveDelegatesCount] = useState(() => {
    return Number(localStorage.getItem('active_delegates_count') || '0');
  });
  // eslint-disable-next-line no-unused-vars
  const [activeAiDocsCount, setActiveAiDocsCount] = useState(() => {
    return Number(localStorage.getItem('ai_documents_count') || '0');
  });

  const [isTemplateAssigned, setIsTemplateAssigned] = useState(() => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return !!userInfo.is_template_assigned;
    } catch {
      return false;
    }
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isSavingQuestions, setIsSavingQuestions] = useState(false);
  const [isImportingQuestions, setIsImportingQuestions] = useState(false);
  const [questionsCount, setQuestionsCount] = useState(0);

  useEffect(() => {
    const handleUnsavedChangesChange = (e) => {
      if (e?.detail) {
        setHasUnsavedChanges(!!e.detail.hasUnsavedChanges);
        setIsSavingQuestions(!!e.detail.isSavingQuestions);
        if (typeof e.detail.questionsCount === 'number') {
          setQuestionsCount(e.detail.questionsCount);
        }
      }
    };
    window.addEventListener('sectionUnsavedChangesChanged', handleUnsavedChangesChange);
    return () => window.removeEventListener('sectionUnsavedChangesChanged', handleUnsavedChangesChange);
  }, []);

  useEffect(() => {
    const handleImportStart = () => setIsImportingQuestions(true);
    const handleImportEnd = () => setIsImportingQuestions(false);
    window.addEventListener('questionImportStarted', handleImportStart);
    window.addEventListener('questionImportFinished', handleImportEnd);
    return () => {
      window.removeEventListener('questionImportStarted', handleImportStart);
      window.removeEventListener('questionImportFinished', handleImportEnd);
    };
  }, []);

  useEffect(() => {
    const handleSiteNameUpdate = () => {
      setSiteNameVersion((v) => v + 1);
    };
    window.addEventListener('siteNameUpdated', handleSiteNameUpdate);
    return () => window.removeEventListener('siteNameUpdated', handleSiteNameUpdate);
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        setIsTemplateAssigned(!!userInfo.is_template_assigned);
        setSub(userInfo?.subscription || 'Basic');
      } catch {
        setIsTemplateAssigned(false);
        setSub('Basic');
      }
      setActiveAuditorsCount(Number(localStorage.getItem('active_auditors_count') || '0'));
      setActiveDelegatesCount(Number(localStorage.getItem('active_delegates_count') || '0'));
      setActiveAiDocsCount(Number(localStorage.getItem('ai_documents_count') || '0'));
    };
    window.addEventListener('storage', handleStorageChange);
    const handleAiDocsUpdate = () => {
      setActiveAiDocsCount(Number(localStorage.getItem('ai_documents_count') || '0'));
    };
    window.addEventListener('aiDocsCountUpdated', handleAiDocsUpdate);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('aiDocsCountUpdated', handleAiDocsUpdate);
    };
  }, []);

  const searchTerm = searchParams.get('search') || '';
  // const statusFilter = searchParams.get('status') || (location.pathname === '/admin/manage-sites' ? '' : 'all');
  // const auditTypeFilter = searchParams.get('audit_type') || 'all';

  useEffect(() => {
    navigation.items.map((item, index) => {
      if (item.type && item.type === 'group') {
        getCollapse(item, index);
      }
      return false;
    });
  });

  useEffect(() => {
    const isSitesPath = location.pathname.startsWith('/admin/manage-sites') || location.pathname.startsWith('/admin/site/');
    if (!isSitesPath) {
      sessionStorage.removeItem('shouldRestoreSitesFilters');
    }

    const isReportsPath = location.pathname.startsWith('/admin/audit-reports');
    if (!isReportsPath) {
      sessionStorage.removeItem('shouldRestoreReportsFilters');
    }
  }, [location.pathname]);

  const getCollapse = (item, index) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse, index);
        } else if (collapse.type && collapse.type === 'item') {
          if (
            location.pathname === collapse.url ||
            (collapse.url === '/admin/manage-templates' && location.pathname.startsWith('/admin/manage-templates/')) ||
            (collapse.url === '/admin/audit-reports' && location.pathname.startsWith('/admin/audit-reports/')) ||
            (collapse.url === '/admin/my-chapters' && location.pathname.startsWith('/admin/my-chapters/')) ||
            (collapse.url === '/admin/dashboard' && location.pathname.startsWith('/admin/dashboard/'))
          ) {
            setMain(item);
            setItem(collapse);
          }
        }
        return false;
      });
    }
  };

  const handleSearchChange = (val) => {
    setSearchParams((prev) => {
      if (val) prev.set('search', val);
      else prev.delete('search');
      return prev;
    });
  };

  // const handleFilterChange = (val) => {
  //   setSearchParams((prev) => {
  //     if (val !== 'all') prev.set('status', val);
  //     else prev.delete('status');
  //     return prev;
  //   });
  // };

  // const handleAuditTypeChange = (val) => {
  //   setSearchParams(prev => {
  //     if (val !== 'all') prev.set('audit_type', val);
  //     else prev.delete('audit_type');
  //     return prev;
  //   });
  // };

  let mainContent, itemContent;
  let breadcrumbContent = '';
  let title = '';

  if (main && main.type === 'collapse') {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to="#" style={{ color: '#333333', textDecoration: 'none' }}>
          {main.title}
        </Link>
      </ListGroup.Item>
    );
  }

  if (item && item.type === 'item') {
    const isQuestionnaireSubPage =
      location.pathname.startsWith('/admin/manage-templates/') && location.pathname !== '/admin/manage-templates';
    const isGlobalTemplate = location.state?.isGlobal;
    const itemTitle = isQuestionnaireSubPage ? (isGlobalTemplate ? 'Global Templates' : 'My Created Templates') : item.title;

    title = isQuestionnaireSubPage ? location.state?.templateName || itemTitle : item.title;
    // if (location.pathname === '/admin/manage-sites') {
    //   title = 'Auditor Audit';
    // }

    itemContent = (
      <ListGroup.Item as="li" bsPrefix=" " className={`breadcrumb-item ${!isQuestionnaireSubPage ? 'active-breadcrumb' : ''}`}>
        {isQuestionnaireSubPage ? (
          <Link to={item.url} style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
            <span className="breadcrumb-text-truncate" title={itemTitle}>{itemTitle}</span>
          </Link>
        ) : (
          <span className="breadcrumb-text-truncate" title={item.title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{item.title}</span>
        )}
      </ListGroup.Item>
    );

    const isAuditorsPage = location.pathname === '/admin/manage-auditors';
    const isAuditLogPage = location.pathname === '/admin/audit-log';
    const isSitesPage = location.pathname === '/admin/manage-sites';
    const isIBPPage = location.pathname === '/admin/ibp-reference';
    const isQuestionnairePage = location.pathname === '/admin/manage-templates';
    const isMyChaptersPage = location.pathname === '/admin/my-chapters';
    const isAuditReportsPage = location.pathname === '/admin/audit-reports';
    const isDelegateRolePage = location.pathname === '/admin/manage-delegate-role';
    const isAuditReportDetailPage = location.pathname.startsWith('/admin/audit-reports/') && location.pathname !== '/admin/audit-reports';
    const isMainAuditReportDetailPage =
      isAuditReportDetailPage &&
      !location.pathname.includes('/full-report') &&
      !location.pathname.includes('/enhanced-report') &&
      !location.pathname.includes('/version/');
    const isChapterDetailsPage = location.pathname.startsWith('/admin/my-chapters/') && location.pathname !== '/admin/my-chapters';
    const isClientManagementPage = location.pathname === '/admin/client-management';
    const isSupportTicketsPage = location.pathname === '/admin/support-tickets' && !searchParams.get('ticketId');
    const ticketIdParam = searchParams.get('ticketId');
    const isTicketDetailPage = location.pathname === '/admin/support-tickets' && !!ticketIdParam;
    const isHelpTutorialsPage = location.pathname === '/admin/help-tutorials';
    const isAiDocumentsPage = location.pathname === '/admin/ai-documents';
    const isSuccessAnalysisDetailsPage = location.pathname === '/admin/dashboard/success-analysis-details';
    const isSuccessFullReportPage = location.pathname.startsWith('/admin/dashboard/full-report/');

    if (isSuccessAnalysisDetailsPage) {
      title = 'Site Compliance Listing';
    }

    if (isSuccessFullReportPage) {
      const match = location.pathname.match(/\/admin\/dashboard\/full-report\/(\d+)/);
      const sId = match ? match[1] : null;
      title = (sId ? sessionStorage.getItem('siteName_' + sId) : null) || location.state?.siteName || 'Full Report';
    }

    if (isAuditReportDetailPage) {
      const match = location.pathname.match(/\/admin\/audit-reports\/(\d+)/);
      const sId = match ? match[1] : null;
      title = (sId ? sessionStorage.getItem('siteName_' + sId) : null) || location.state?.siteName || 'Fusion Innovation Center (Sample)';
    }

    if (isChapterDetailsPage) {
      title = location.state?.chapterName || 'Section Details';
    }

    if (isTicketDetailPage) {
      title = sessionStorage.getItem('ticketNumber_' + ticketIdParam) || `Ticket #${ticketIdParam}`;
    }

    if (
      item.breadcrumbs !== false ||
      isAuditReportDetailPage ||
      isChapterDetailsPage ||
      isTicketDetailPage ||
      isSuccessAnalysisDetailsPage ||
      isSuccessFullReportPage
    ) {
      if (isSuccessFullReportPage) {
        itemContent = (
          <>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
              <Link to="/admin/dashboard/success-analysis-details" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                Site Compliance Listing
              </Link>
            </ListGroup.Item>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
              <span className="breadcrumb-text-truncate" title={title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{title}</span>
            </ListGroup.Item>
          </>
        );
      } else if (isSuccessAnalysisDetailsPage) {
        itemContent = (
          <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
            <span className="breadcrumb-text-truncate" title={title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{title}</span>
          </ListGroup.Item>
        );
      } else if (isChapterDetailsPage) {
        itemContent = (
          <>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
              <Link to="/admin/my-chapters" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                My Sections
              </Link>
            </ListGroup.Item>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
              <span className="breadcrumb-text-truncate" title={title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{title}</span>
            </ListGroup.Item>
          </>
        );
      } else if (isTicketDetailPage) {
        itemContent = (
          <>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
              <Link to="/admin/support-tickets" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                Support Ticket
              </Link>
            </ListGroup.Item>
            <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
              <span className="breadcrumb-text-truncate" title={title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{title}</span>
            </ListGroup.Item>
          </>
        );
      } else if (isAuditReportDetailPage) {
        const match = location.pathname.match(/\/admin\/audit-reports\/(\d+)/);
        const sId = match ? match[1] : null;

        const matchVersion = location.pathname.match(/\/admin\/audit-reports\/\d+\/version\/([^/]+)/);
        const versionParam = matchVersion ? matchVersion[1] : null;

        const isFullReport = location.pathname.includes('/full-report');
        const isEnhancedReport = location.pathname.includes('/enhanced-report');

        if (versionParam) {
          itemContent = (
            <>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link to="/admin/audit-reports" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                  Audit Reports
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link
                  to={sessionStorage.getItem('isSingleVersion_' + sId) === 'true' ? '/admin/audit-reports' : `/admin/audit-reports/${sId}`}
                  style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                >
                  <span className="breadcrumb-text-truncate" title={title}>{title}</span>
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
                <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>Version {versionParam}</span>
              </ListGroup.Item>
            </>
          );
        } else if (isFullReport) {
          const searchParams = new URLSearchParams(location.search);
          const qVersion = searchParams.get('version');

          itemContent = (
            <>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link to="/admin/audit-reports" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                  Audit Reports
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link
                  to={sessionStorage.getItem('isSingleVersion_' + sId) === 'true' ? '/admin/audit-reports' : `/admin/audit-reports/${sId}`}
                  style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                >
                  <span className="breadcrumb-text-truncate" title={title}>{title}</span>
                </Link>
              </ListGroup.Item>
              {qVersion && (
                <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                  <Link
                    to={`/admin/audit-reports/${sId}/version/${qVersion}`}
                    style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                  >
                    Version {qVersion}
                  </Link>
                </ListGroup.Item>
              )}
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
                <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>Full Report</span>
              </ListGroup.Item>
            </>
          );
        } else if (isEnhancedReport) {
          const searchParams = new URLSearchParams(location.search);
          const qVersion = searchParams.get('version');

          itemContent = (
            <>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link to="/admin/audit-reports" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                  Audit Reports
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link
                  to={sessionStorage.getItem('isSingleVersion_' + sId) === 'true' ? '/admin/audit-reports' : `/admin/audit-reports/${sId}`}
                  style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                >
                  <span className="breadcrumb-text-truncate" title={title}>{title}</span>
                </Link>
              </ListGroup.Item>
              {qVersion && (
                <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                  <Link
                    to={`/admin/audit-reports/${sId}/version/${qVersion}`}
                    style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                  >
                    Version {qVersion}
                  </Link>
                </ListGroup.Item>
              )}
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
                <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>Enhanced Report</span>
              </ListGroup.Item>
            </>
          );
        } else {
          itemContent = (
            <>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                <Link to="/admin/audit-reports" style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}>
                  Audit Reports
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
                <span className="breadcrumb-text-truncate" title={title} style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{title}</span>
              </ListGroup.Item>
            </>
          );
        }
      }

      if (isHelpTutorialsPage && isSuperAdmin) {
        title = 'Manage Tutorials';
        itemContent = (
          <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
            <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>Manage Tutorials</span>
          </ListGroup.Item>
        );
      }

      breadcrumbContent = (
        <div className="page-header" style={{ marginBottom: '20px' }}>
          <div className="page-block">
            <div className="row align-items-start">
              <div className="col-md-12 d-flex justify-content-between align-items-start flex-wrap">
                <div style={{ marginRight: '20px', minWidth: 0, flex: '1 1 auto', overflowWrap: 'break-word', wordBreak: 'break-all' }}>
                  <div className="page-header-title">
                    <h5 className="page-breadcrumb-title m-b-10" style={{ overflowWrap: 'break-word', wordBreak: 'break-all' }}>
                      {title}
                    </h5>
                  </div>
                  <ListGroup as="ul" bsPrefix=" " className="breadcrumb" style={{ fontSize: '13px' }}>
                    <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                      <Link to="/admin/dashboard" style={{ color: '#333333', textDecoration: 'none' }}>
                        Dashboard
                      </Link>
                    </ListGroup.Item>
                    {mainContent}
                    {itemContent}
                    {isQuestionnaireSubPage && (
                      <ListGroup.Item
                        as="li"
                        bsPrefix=" "
                        className={`breadcrumb-item ${!location.state?.templateName ? 'active-breadcrumb' : ''}`}
                      >
                        {location.state?.templateName ? (
                          <Link
                            to={`${item.url}?tab=${isGlobalTemplate ? 'global' : 'my'}`}
                            style={{ color: '#333333', fontWeight: '400', textDecoration: 'none' }}
                          >
                            {itemTitle}
                          </Link>
                        ) : (
                          <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{itemTitle}</span>
                        )}
                      </ListGroup.Item>
                    )}
                    {isQuestionnaireSubPage && location.state?.templateName && (
                      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item active-breadcrumb">
                        <span style={{ color: '#005457', fontWeight: '600', textDecoration: 'none' }}>{location.state.templateName}</span>
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                </div>

                {isAuditorsPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      {/* <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '4px', display: 'block' }}>Search Auditor</label> */}
                      <SearchInput
                        placeholder="Search Auditor"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px', marginBottom: '0px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    {canManageAuditor && (
                      <div>
                        {(() => {
                          const tier = getSubscriptionTier(sub);
                          const limit = getAuditorsLimit(tier);
                          const isLimitReached = activeAuditorsCount >= limit;
                          const planLabel = sub === 'Basic' ? 'Bronze' : sub;
                          return (
                            <CommonButton
                              onClick={() => {
                                if (isLimitReached) {
                                  if (tier === 'gold') {
                                    setUpgradeTitle('Auditor Limit Reached');
                                    setUpgradeMessage(
                                      `You have reached the maximum limit of ${limit} auditors allowed under your Gold subscription plan. To add a new auditor, delete an existing auditor first.`
                                    );
                                    setUpgradeSubmitLabel('Okay');
                                    setUpgradeType('deactivate');
                                  } else {
                                    setUpgradeTitle('Upgrade Required');
                                    setUpgradeMessage(
                                      `${planLabel} plan allows maximum ${limit} auditors. Upgrade subscription to add more auditors.`
                                    );
                                    setUpgradeSubmitLabel('Upgrade Plan');
                                    setUpgradeType('upgrade');
                                  }
                                  setShowUpgradeModal(true);
                                } else {
                                  setSearchParams((prev) => {
                                    prev.set('add', 'true');
                                    return prev;
                                  });
                                }
                              }}
                              style={{
                                color: isLimitReached ? '#94A3B8' : '#fff',
                                backgroundColor: isLimitReached ? '#E2E8F0' : '#005457',
                                borderColor: isLimitReached ? '#E2E8F0' : '#005457',
                                cursor: isLimitReached ? 'not-allowed' : 'pointer'
                              }}
                              title={isLimitReached ? `${planLabel} plan allows maximum ${limit} auditors.` : 'Add Auditor'}
                              aria-label={
                                isLimitReached
                                  ? `Add Auditor button disabled. maximum auditor limit reached. plan upgrade required.`
                                  : 'Add Auditor'
                              }
                            >
                              Add Auditor
                            </CommonButton>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                )}

                {isAuditLogPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search Audit Log"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px', marginBottom: '0px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                  </div>
                )}

                {isSitesPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      {/* <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '4px', display: 'block' }}>Search Site</label> */}
                      <SearchInput
                        placeholder="Search Auditor"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('sort', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Sort By <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>

                    {/* <div className="me-3">
                      <CommonDropdown
                        options={[
                          { label: 'All Types', value: 'all' },
                          { label: 'Plan Review', value: 'Plan Review' },
                          { label: 'Onsite Review', value: 'Onsite Review' },
                          { label: 'Other', value: 'Other' }
                        ]}
                        value={auditTypeFilter}
                        onChange={handleAuditTypeChange}
                        placeholder="Filter by Type"
                      />
                    </div> */}

                    {/* <div className="me-3">
                      <CommonDropdown
                        options={[
                          { label: 'All Types', value: 'all' },
                          { label: 'Plan Review', value: 'Plan Review' },
                          { label: 'Onsite Review', value: 'Onsite Review' },
                          { label: 'Other', value: 'Other' }
                        ]}
                        value={auditTypeFilter}
                        onChange={handleAuditTypeChange}
                        placeholder="Filter by Type"
                      />
                    </div> */}

                    {searchParams.get('tab') !== 'auditor' && canManageSites && (
                      <div>
                        <CommonButton
                          onClick={() => {
                            if (!isTemplateAssigned) {
                              showNotification('No Template Assigned, Please assign a template first than create site.', 'error');
                            } else {
                              setSearchParams((prev) => {
                                prev.set('add', 'true');
                                return prev;
                              });
                            }
                          }}
                          style={{ color: '#fff', backgroundColor: '#005457', borderColor: '#005457', height: '42px' }}
                        >
                          Add Audit
                        </CommonButton>
                      </div>
                    )}
                  </div>
                )}

                {/* Master Questionnaire Filters */}
                {/* {location.pathname === '/admin/questionnaire' && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0">
                    <div className="me-3">
                      <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '4px', display: 'block' }}>Search Master Questions</label>
                      <SearchInput
                        placeholder="Search text or code..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '450px' }}
                      />
                    </div>
                    <div className="pt-3">
                      <CommonButton
                        onClick={() => {
                          setSearchParams(prev => {
                            prev.set('addQuestion', 'true');
                            return prev;
                          });
                        }}
                        style={{ backgroundColor: '#005457', borderColor: '#005457' }}
                      >
                        + Add Question
                      </CommonButton>
                    </div>
                  </div>
                )} */}
                {isIBPPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0">
                    <div className="me-3">
                      <SearchInput placeholder="Search IBP" value={searchTerm} onChange={handleSearchChange} style={{ width: '400px' }} />
                    </div>
                    {canManageIBP && (
                      <div>
                        <CommonButton
                          onClick={() =>
                            setSearchParams((prev) => {
                              prev.set('add', 'true');
                              return prev;
                            })
                          }
                          style={{ color: '#fff', backgroundColor: '#005457', borderColor: '#005457' }}
                          aria-label="Add New IBP"
                        >
                          Add New IBP
                        </CommonButton>
                      </div>
                    )}
                  </div>
                )}

                {isQuestionnairePage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search Template"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px' }}
                      />
                    </div>
                    {(searchParams.get('tab') === 'my' || isSuperAdmin) && (
                      <div className="d-flex gap-3">
                        {canManageTemplate && !isSuperAdmin && (
                          <CommonButton
                            onClick={() =>
                              setSearchParams((prev) => {
                                prev.set('selfAssign', 'true');
                                return prev;
                              })
                            }
                            style={{
                              color: '#005457',
                              backgroundColor: '#fff',
                              border: '1.5px solid #005457',
                              height: '42px',
                              fontWeight: '500',
                              fontSize: '14px',
                              borderRadius: '10px',
                              padding: '10px 20px',
                              boxShadow: 'none'
                            }}
                          >
                            {isTemplateAssigned ? 'Change Template' : 'Self Assign Template'}
                          </CommonButton>
                        )}
                        {canManageTemplate && (
                          <CommonButton
                            onClick={() =>
                              setSearchParams((prev) => {
                                prev.set('add', 'true');
                                return prev;
                              })
                            }
                            style={{
                              color: '#fff',
                              backgroundColor: '#005457',
                              borderColor: '#005457',
                              opacity: isSuperAdmin || String(sub || '').toLowerCase() === 'gold' ? 1 : 0.7
                            }}
                          >
                            {isSuperAdmin || String(sub || '').toLowerCase() === 'gold' ? null : <i className="bi bi-lock me-1"></i>}
                            Create Template
                          </CommonButton>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {isMyChaptersPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search Section"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('sort', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Sort By <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    {canManageChapter && (
                      <div>
                        {(() => {
                          const chapterQuotaUsed = Number(localStorage.getItem('chapter_quota_used') || '0');
                          const isChapterLimitReached = !isSuperAdmin && chapterQuotaUsed >= 50;
                          if (isChapterLimitReached) return null;
                          return (
                            <CommonButton
                              onClick={() => {
                                setSearchParams((prev) => {
                                  prev.set('add', 'true');
                                  return prev;
                                });
                              }}
                              style={{
                                color: '#fff',
                                backgroundColor: '#005457',
                                borderColor: '#005457',
                                height: '42px',
                                fontWeight: '500',
                                fontSize: '16px',
                                borderRadius: '10px',
                                padding: '10px 20px',
                                boxShadow: 'none'
                              }}
                            >
                              Add Section
                            </CommonButton>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                )}
                {isChapterDetailsPage && (
                  <div className="header-controls d-flex flex-column align-items-end mt-2 mt-md-0 gap-2">
                    <div style={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}>
                      <SearchInput
                        placeholder="Search questions"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '100%' }}
                      />
                    </div>
                    {canManageChapter && (
                      <div className="d-flex gap-2 justify-content-end flex-wrap">
                        <CommonButton
                          className={`btn-save-questions ${!hasUnsavedChanges || isSavingQuestions ? '' : 'text-white'}`}
                          onClick={() => {
                            window.dispatchEvent(new Event('triggerSectionSave'));
                          }}
                          disabled={!hasUnsavedChanges || isSavingQuestions}
                          style={{
                            backgroundColor: !hasUnsavedChanges || isSavingQuestions ? '#E0E0E0' : '#005457',
                            color: !hasUnsavedChanges || isSavingQuestions ? '#9E9E9E' : '#ffffff',
                            height: '42px',
                            fontWeight: '600',
                            fontSize: '16px',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            boxShadow: 'none'
                          }}
                        >
                          {isSavingQuestions ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              Saving...
                            </>
                          ) : (
                            'Save'
                          )}
                        </CommonButton>
                        <CommonButton
                          onClick={() => {
                            setSearchParams((prev) => {
                              prev.set('addQuestion', 'true');
                              return prev;
                            });
                          }}
                          style={{
                            color: '#fff',
                            backgroundColor: '#005457',
                            borderColor: '#005457',
                            height: '42px',
                            fontWeight: '600',
                            fontSize: '16px',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            boxShadow: 'none'
                          }}
                        >
                          Add Question
                        </CommonButton>
                        <CommonButton
                          onClick={() => {
                            window.dispatchEvent(new Event('triggerQuestionImport'));
                          }}
                          disabled={isImportingQuestions}
                          style={{
                            color: isImportingQuestions ? '#9E9E9E' : '#fff',
                            backgroundColor: isImportingQuestions ? '#E0E0E0' : '#005457',
                            borderColor: isImportingQuestions ? '#E0E0E0' : '#005457',
                            height: '42px',
                            fontWeight: '600',
                            fontSize: '16px',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            boxShadow: 'none'
                          }}
                        >
                          {isImportingQuestions ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              Importing...
                            </>
                          ) : (
                            'Import Questions'
                          )}
                        </CommonButton>
                        {isSuperAdmin && (
                          <CommonButton
                            onClick={() => {
                              window.dispatchEvent(new Event('triggerQuestionExport'));
                            }}
                            disabled={questionsCount === 0}
                            style={{
                              color: questionsCount === 0 ? '#9E9E9E' : '#fff',
                              backgroundColor: questionsCount === 0 ? '#E0E0E0' : '#005457',
                              borderColor: questionsCount === 0 ? '#E0E0E0' : '#005457',
                              height: '42px',
                              fontWeight: '600',
                              fontSize: '16px',
                              borderRadius: '8px',
                              padding: '10px 20px',
                              boxShadow: 'none',
                              cursor: questionsCount === 0 ? 'not-allowed' : 'pointer'
                            }}
                          >
                            Export Questions
                          </CommonButton>
                        )}
                        <CommonButton
                          onClick={() => {
                            window.dispatchEvent(new Event('triggerSampleSheetDownload'));
                          }}
                          style={{
                            color: '#fff',
                            backgroundColor: '#005457',
                            borderColor: '#005457',
                            height: '42px',
                            fontWeight: '600',
                            fontSize: '16px',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            boxShadow: 'none'
                          }}
                        >
                          Download Sample Sheet
                        </CommonButton>
                      </div>
                    )}
                  </div>
                )}
                {isAuditReportsPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search Report"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('sort', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Sort By <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                  </div>
                )}
                {isDelegateRolePage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    {canManageCustomRole && (
                      <div>
                        {(() => {
                          const tier = getSubscriptionTier(sub);
                          const limit = getDelegateAdminsLimit(tier);
                          const isLimitReached = activeDelegatesCount >= limit;
                          const planLabel = sub === 'Basic' ? 'Bronze' : sub;
                          return (
                            <CommonButton
                              onClick={() => {
                                const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                                const subStatus = userInfo?.subscription_status || 'active';
                                const isSubscriptionSuspended = subStatus === 'suspended' || subStatus === 'expired';

                                if (isSubscriptionSuspended) {
                                  setUpgradeTitle('Subscription Inactive');
                                  setUpgradeMessage('Subscription inactive. Reactivate subscription to continue.');
                                  setUpgradeSubmitLabel('Reactivate Subscription');
                                  setUpgradeType(null);
                                  setShowUpgradeModal(true);
                                } else if (isLimitReached) {
                                  if (tier === 'gold') {
                                    setUpgradeTitle('Delegate Admin Limit Reached');
                                    setUpgradeMessage(
                                      `You have reached the maximum limit of ${limit} Delegate Admins allowed under your Gold subscription plan. To add a new Delegate Admin, deactivate or delete an existing Delegate Admin first.`
                                    );
                                    setUpgradeSubmitLabel('Okay');
                                    setUpgradeType('limitReached');
                                  } else {
                                    setUpgradeTitle('Upgrade Required');
                                    setUpgradeMessage(`Delegate Admin limit reached. Upgrade subscription to add more Delegate Admins.`);
                                    setUpgradeSubmitLabel('Upgrade Plan');
                                    setUpgradeType('upgrade');
                                  }
                                  setShowUpgradeModal(true);
                                } else {
                                  setSearchParams((prev) => {
                                    prev.set('add', 'true');
                                    return prev;
                                  });
                                }
                              }}
                              style={{
                                color: isLimitReached ? '#94A3B8' : '#fff',
                                backgroundColor: isLimitReached ? '#E2E8F0' : '#005457',
                                borderColor: isLimitReached ? '#E2E8F0' : '#005457',
                                cursor: isLimitReached ? 'not-allowed' : 'pointer'
                              }}
                              title={isLimitReached ? `${planLabel} plan allows maximum ${limit} delegates.` : 'Add Delegate'}
                              aria-label={
                                isLimitReached
                                  ? `Add Delegate button disabled. maximum delegate limit reached. plan upgrade required.`
                                  : 'Add Delegate'
                              }
                            >
                              Add Delegate
                            </CommonButton>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                )}
                {isClientManagementPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search clients..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '300px', marginBottom: '0px' }}
                      />
                    </div>
                  </div>
                )}
                {isSupportTicketsPage && !isSuperAdmin && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search Ticket"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '400px', marginBottom: '0px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() =>
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          })
                        }
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    {canManageSupportTicket && (
                      <div>
                        <CommonButton
                          onClick={() => {
                            setSearchParams((prev) => {
                              prev.set('add', 'true');
                              return prev;
                            });
                          }}
                          style={{
                            color: '#fff',
                            backgroundColor: '#005457',
                            borderColor: '#005457',
                            height: '42px',
                            fontWeight: '600',
                            fontSize: '16px',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            boxShadow: 'none'
                          }}
                          title="Create Ticket"
                          aria-label="Create support ticket"
                        >
                          Create Ticket
                        </CommonButton>
                      </div>
                    )}
                  </div>
                )}
                {isHelpTutorialsPage && isSuperAdmin && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search tutorials"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '250px', marginBottom: '0px' }}
                      />
                    </div>
                    <div>
                      <CommonButton
                        onClick={() => {
                          setSearchParams((prev) => {
                            prev.set('filter', 'true');
                            return prev;
                          });
                        }}
                        style={{
                          color: '#333333',
                          backgroundColor: '#fff',
                          border: '1.5px solid #333333',
                          height: '42px',
                          fontWeight: '400',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none'
                        }}
                        title="Filter Audience"
                        aria-label="Filter audience"
                      >
                        Filter by <FiChevronDown className="ms-3" style={{ fontSize: '18px', color: '#333333' }} />
                      </CommonButton>
                    </div>
                    <div>
                      <CommonButton
                        onClick={() => {
                          setSearchParams((prev) => {
                            prev.set('add', 'true');
                            return prev;
                          });
                        }}
                        style={{
                          color: '#fff',
                          backgroundColor: '#005457',
                          borderColor: '#005457'
                        }}
                        title="Add Tutorial"
                        aria-label="Add new tutorial"
                      >
                        Add Tutorial
                      </CommonButton>
                    </div>
                  </div>
                )}
                {isAiDocumentsPage && isSuperAdmin && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <CommonButton
                        onClick={() => {
                          setSearchParams((prev) => {
                            prev.set('add', 'true');
                            return prev;
                          });
                        }}
                        style={{
                          color: '#fff',
                          backgroundColor: '#005457',
                          borderColor: '#005457'
                        }}
                        title="Upload Documents"
                        aria-label="Upload new AI document"
                      >
                        Upload Documents
                      </CommonButton>
                    </div>
                  </div>
                )}
                {isMainAuditReportDetailPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <CommonButton
                        onClick={() => {
                          setSearchParams((prev) => {
                            prev.set('showEnhanced', 'true');
                            return prev;
                          });
                        }}
                        style={{
                          color: '#fff',
                          backgroundColor: '#005457',
                          borderColor: '#005457',
                          height: '42px',
                          fontWeight: '500',
                          fontSize: '16px',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          boxShadow: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                        title="View Enhanced Report"
                        aria-label="View enhanced report"
                      >
                        <img src={docIcon} alt="Report icon" style={{ width: '16px', height: '16px', filter: 'brightness(0) invert(1)' }} />
                        View Enhanced Report
                      </CommonButton>
                    </div>
                  </div>
                )}
                {isSuccessAnalysisDetailsPage && (
                  <div className="header-controls d-flex align-items-center flex-wrap mt-2 mt-md-0 gap-3">
                    <div>
                      <SearchInput
                        placeholder="Search by Site Name..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '300px', marginBottom: '0px' }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (isChapterDetailsPage) {
      document.title = `My Sections_${title}`;
    } else {
      document.title = title + BASE_TITLE;
    }
  }

  if (isSiteDetailPage || isAssessmentPage || isDashboardPage) return null;

  const tier = getSubscriptionTier(sub);
  const limit = getAuditorsLimit(tier);
  const planLabel = sub === 'Basic' ? 'Bronze' : sub;

  return (
    <React.Fragment>
      {breadcrumbContent}
      {showUpgradeModal && (
        <CommonModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
          title={upgradeTitle || 'Upgrade Required'}
          message={
            upgradeMessage === 'Upgrade your subscription to access features.'
              ? `${planLabel} plan allows maximum ${limit} auditors. Upgrade subscription to add more auditors.`
              : upgradeMessage
          }
          disableFocusTrap={false}
          type={upgradeType}
          onConfirm={upgradeSubmitLabel === 'Okay' ? () => setShowUpgradeModal(false) : undefined}
          confirmText={upgradeSubmitLabel === 'Okay' ? 'Okay' : undefined}
        >
          {upgradeSubmitLabel !== 'Okay' && (
            <ModalFooter
              onCancel={() => setShowUpgradeModal(false)}
              onSubmit={() => {
                setShowUpgradeModal(false);
                navigate('/admin/subscription?tab=plans');
              }}
              submitLabel={upgradeSubmitLabel || 'Upgrade Plan'}
              cancelLabel="Cancel"
              submitType="button"
            />
          )}
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default Breadcrumb;
